import React from 'react';
import classnames from 'classnames';
import { getThumbGlobalClassNames } from '../../helpers';
import { getDeviationTitle } from '../../../../DeviationViews/_helpers';
import EditorDeviationLink from '../../_partials/DeviationLink';
const CommissionMonoHtmlView = (props)=>{
    const { deviation, config: { link } } = props;
    return /*#__PURE__*/ React.createElement(EditorDeviationLink, {
        link: link,
        deviation: deviation
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames('daeditor-freeform-root', getThumbGlobalClassNames(deviation), props.config && props.config.alignment && `daeditor-align-${props.config.alignment}`, props.settings && props.settings.showMediaAlwaysSmall && `daeditor-small`)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-freeform-header"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "daeditor-freeform-title"
    }, getDeviationTitle(deviation)))));
};
CommissionMonoHtmlView.displayName = 'CommissionMonoHtmlView';
export default CommissionMonoHtmlView;
